// react
import React, { Fragment } from 'react';
import styled from 'styled-components';

// components
import { Skeleton } from '@/components/atoms';

export const LoadingWebinar = () => {
  return (
    <Wrapper>
      {[1, 2, 3].map((n: number) => (
        <Fragment key={n}>
          <Skeleton shape='title' />
          <Skeleton shape='paragraph' />
          <Skeleton shape='subtitle' />
          <Skeleton shape='paragraph' />
        </Fragment>
      ))}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export default LoadingWebinar;
